import React from 'react';
import moment from "moment";
import FormGroupTextInput from "../formGroupTextInput";
import FormGroupTextArea from "../formGroupTextArea";
import _ from "lodash";
import FormGroupSelectInput from "../formGroupSelectInput";
import {FLOAT_REGEX} from "../../helpers/variables";
import FormGroupDateInput from "../General/formGroupDateInput";
import Tooltip from '../General/tooltip';

const ClientDetailsQuestion = (props) => {

    //calendar question?
    if(props.question.inputType === 'calendar'){
        let value =  props.clientDetailsForm[props.question.id];
        let  minDate ;
        // date field
        minDate = moment().format('DD/MM/YYYY');
        return (
            <FormGroupDateInput
                autoComplete={'off'}
                centerClassName="col-sm-6 formGroup-textInput-input-wrapper"
                leftClassName="col-sm-3"
                label={props.question.name}
                required={props.question.isRequired}
                name={props.question.id}
                Key={props.question.id}
                min={minDate}
                type="text"
                value={value}
                handleInputChange={(key, value) => props.changeQuoteClientDetailsForm({key: key, value: value})}
                rightClassName={'col-sm-3'}
                rightData={
                    props.question.tooltip?
                        <Tooltip text={props.question.tooltip}/>:null
                }              
            />
        )
    }

    //amount question?
    if(props.question.inputType === 'amount'){
        let errMsg = '';
        let s = props.clientDetailsForm[props.question.id].toString().split(/\.|,/);
        try {
            if(s[0].length > 15) errMsg = 'Value must be less or equal to 999,999,999,999,999.99';
            if(s[1].length > 2) errMsg = 'Number input should have at most 2 decimals';
        } catch (e) {}
        if(isNaN(props.clientDetailsForm[props.question.id])) errMsg = 'Input in not a valid number';
        return (
            <FormGroupTextInput
                autoComplete={'off'}
                title={errMsg}
                pattern={FLOAT_REGEX.source}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={props.question.name}
                Required={props.question.isRequired}
                Name={props.question.id}
                key={props.question.id}
                Type="text" Value={props.clientDetailsForm[props.question.id]}
                HandleInputChange={(key, value) => props.changeQuoteClientDetailsForm({key: key, value: value})}
                RightWrapper={'col-sm-3'}
                rightData={
                    props.question.tooltip?
                        <Tooltip text={props.question.tooltip}/>:null
                }
            />
        )
    }

    //text question?
    if(props.question.inputType === 'text'){
        return (
            <FormGroupTextInput
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={props.question.name}
                Required={props.question.isRequired}
                Name={props.question.id}
                key={props.question.id}
                Type="text"
                Value={props.clientDetailsForm[props.question.id]}
                HandleInputChange={(key, value) => props.changeQuoteClientDetailsForm({key: key, value: value})}
                RightWrapper={'col-sm-3'}
                rightData={
                    props.question.tooltip?
                        <Tooltip text={props.question.tooltip}/>:null
                }
            />
        )
    }

    //text question?
    if(props.question.inputType === 'text area'){
        return (
            <FormGroupTextArea
                autoComplete={'off'}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={props.question.name}
                Required={props.question.isRequired}
                Name={props.question.id}
                key={props.question.id}
                Type="text"
                Value={props.clientDetailsForm[props.question.id]}
                HandleInputChange={(key, value) => props.changeQuoteClientDetailsForm({key: key, value: value})}
                RightWrapper={'col-sm-3'}
                rightData={
                    props.question.tooltip?
                        <Tooltip text={props.question.tooltip}/>:null
                }
            />
        )
    }

    //text question?
    if(props.question.inputType === 'drop down'){
        let selectedOption = _.find(props.question.options, o => {
            return o.id.toString() === props.clientDetailsForm[props.question.id].toString()
        });
        let childQuestions  = [];
        if(selectedOption){
            childQuestions  = _.filter(props.quoteQuestions, q => {
                return _.find(selectedOption.childQuestions, cq => {return cq.id === q.id})
            });
        }
        return (
            <div>
                <FormGroupSelectInput
                    Label={props.question.name}
                    LeftWrapper="col-sm-3"
                    Required={props.question.isRequired}
                    Name={props.question.id}
                    Value={props.clientDetailsForm[props.question.id]}
                    key={props.question.id}
                    Options={[
                        {key: '', value: ''},
                        ..._.orderBy(props.question.options, 'name').map(o => ({key: o.id, value: o.name}))
                    ]}
                    HandleInputChange={props.handleSelectChange}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                    RightWrapper={'col-sm-3'}
                    rightData={
                        props.question.tooltip?
                            <Tooltip text={props.question.tooltip}/>:null
                    }
                />
                {
                    childQuestions.map(cq => {
                        return (
                            <ClientDetailsQuestion
                                {...props}
                                key={cq.id}
                                question={cq}
                            />
                        )})
                }
            </div>
        )
    }

    return (
        <div>ss</div>
    )
};

export default ClientDetailsQuestion;
